export default __webpack_public_path__ + "media/zurb/img/blog/search-icon-5028ebb377990b0cc019fd401aca03c1.svg";